import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";

export const confirmTask = createAction("CONFIRM_TASK_ACTIVEDTASKS");
export const updateSubtask = createAction("UPDATE_SUBTASK_ACTIVEDTASKS");
export const updateDescription = createAction(
  "UPDATE_DESCRIPTION_ACTIVEDTASKS",
);
export const updateChatLen = createAction("UPDATE_CHAT_LEN");
export const updateFilesLen = createAction("UPDATE_FILES_LEN");

//Accountable
export const updateAccountable = createAction(
  "UPDATE_ACCOUNTABLE_ACTIVEDTASKS",
);
export const removeAccountable = createAction(
  "REMOVE_ACCOUNTABLE_ACTIVEDTASKS",
);
//TaskLabel
export const updateTaskLabel = createAction("UPDATE_TASK_LABEL_ACTIVEDTASKS");

export const updateTaskDeadlinePagination = createAction(
  "UPDATE_TASK_DEADLINE_PAGINATION",
);

export const getRelatory = createAction("GET_RELATORY");

export const handleGetFlowRelatory = ({ flowId }) => {
  return (dispatch) =>
    api
      .get(`/activedtasks/relatory/flow/${flowId}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
};

export const handleConfirm = ({ flowId, taskId }) => {
  return (dispatch) =>
    api
      .put("/activedflows/node/confirm", {
        flowId,
        taskId,
        // edgeId,
      })
      .then((res) => dispatch(confirmTaskSucess(res.data)))
      .catch((err) => dispatch(confirmTaskFailure(err.message)));
};

const confirmTaskSucess = (payload) => confirmTask(payload);

const confirmTaskFailure = (error) => {
  Promise.reject(error);
};

//Subtasks
//New
export const handleAddSubtask = ({ taskId }) => {
  return (dispatch) =>
    api
      .post("/activedflows/task/subtask/new", { taskId })
      .then((res) => dispatch(addSubtaskSucess(res.data)))
      .catch((err) => {
        Promise.reject(err.message);
      });
};
const addSubtaskSucess = (payload) => updateSubtask(payload);

//Remove
export const handleRemoveSubtask = ({ taskId, id }) => {
  return (dispatch) =>
    api
      .delete(`/activedflows/task/subtask/delete/${taskId}/${id}`)
      .then((res) => dispatch(removeSubtaskSucess(res.data)))
      .catch((err) => {
        Promise.reject(err.message);
      });
};
const removeSubtaskSucess = (payload) => updateSubtask(payload);
//Update
export const handleUpdateSubtask = ({ taskId, id, title, checked }) => {
  return (dispatch) =>
    api
      .put("/activedflows/task/subtask/update", { taskId, id, title, checked })
      .then((res) => dispatch(updateSubtaskSucess(res.data)))
      .catch((err) => {
        console.error(err);
        Promise.reject(err.message);
      });
};
const updateSubtaskSucess = (payload) => updateSubtask(payload);

//Task Description
export const handleUpdateDescription = ({ taskId, description }) => {
  return (dispatch) =>
    api
      .put("/activedflows/task/description/", { taskId, description })
      .then((res) => dispatch(updateDescriptionSucess(res.data)))
      .catch((err) => {
        Promise.reject(err.message);
      });
};
const updateDescriptionSucess = (payload) => updateDescription(payload);

export const handleUpdateAccountable = ({ id, userId }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/accountable/", { id, userId })
      .then((res) => dispatch(updateAccSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

export const handleRemoveAccountable = ({ id }) => {
  return (dispatch) =>
    api
      .delete(`/activedtasks/accountable/${id}`)
      .then((res) => dispatch(updateAccSucess(res.data)))
      .catch((err) => Promise.reject(err));
};
const updateAccSucess = (payload) => updateAccountable(payload);

//Rótulo de tarefa
export const handleUpdateTaskLabelAT = ({ label, taskId }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/label/", { label, taskId })
      .then((res) => dispatch(updateTaskLabelSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

const updateTaskLabelSucess = (payload) => updateTaskLabel(payload);

export const handleUpdateDeadlinePagination = ({ taskId, delayTime }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/deadline/", { taskId, delayTime })
      // .then((res) => dispatch(updateTaskDeadlinePagination(res.data)))
      .catch((err) => Promise.reject(err));
};
